import React, { useState, useEffect } from 'react';
import Menu from '../components/menu';
import ImgBannerPartenaire from '../components/imgBannerPartenaire';

const Annonces: React.FC = () => {
    return (
        <div>
            <Menu />

            <div className="h-8 md:h-96 bg-orange-300 mx-auto flex flex-wrap">
                <div className="text-xl md:text-5xl font-bold text-white w-full md:w-1/2 px-2 md:p-10 md:text-left text-center">
                    <p className="inline-block align-middle">Répondez aux annonces</p>
                </div>

                <div className="w-full md:w-1/2 md:block hidden">
                    <ImgBannerPartenaire />
                </div>
            </div>
            
        </div>
    )
}

export default Annonces;